import { useEffect, useState, useRef, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Divider, Stack, Typography } from '@karma/components';
import { useSelector } from 'react-redux';
import * as ALOOMA from 'consts/alooma';
import { OPTIONS_GENRES } from 'consts/karmaEarn';
import Alooma from 'services/alooma';
import useAction from 'hooks/useAction';
import { ResolutionTypeContext } from 'contexts/ResolutionTypeContext';
import { setGenres } from 'store/karmaEarnList/actions';
import { genresSelector } from 'store/karmaEarnList/selectors';
import { Categories, Category, StyledButton } from './ModalBodyKarmaEarnGameGenres.style';

const ModalBodyKarmaEarnGameGenres = ({ closeModal }) => {
  const { isPhoneResolution } = useContext(ResolutionTypeContext);
  const { t } = useTranslation();
  const contextDataAttrs = Alooma.useContextDataAttrs();
  const genres = useSelector(genresSelector);
  const [selectedGenres, setSelectedGenres] = useState(genres);
  const selectedGenresRef = useRef(selectedGenres);
  const setGenresFunc = useAction(setGenres);

  const toggleGenre = genre => {
    const newGenres = selectedGenres.includes(genre)
      ? selectedGenres.filter(v => v !== genre)
      : [...selectedGenres, genre];

    setSelectedGenres(newGenres);
  };

  const resetHandler = () => {
    setSelectedGenres([]);
    selectedGenresRef.current = [];
    closeModal();
  };

  useEffect(() => {
    selectedGenresRef.current = selectedGenres;
  }, [selectedGenres]);

  useEffect(() => {
    return () => {
      setGenresFunc(selectedGenresRef.current);
    };
  }, []);

  return (
    <Stack direction="column" alignItems="flex-start">
      <Typography variant="labelLarge" bMargin={12}>
        {t('app:category')}
      </Typography>
      <Categories>
        {OPTIONS_GENRES.map(genre => (
          <Category
            key={genre.value}
            role="button"
            onClick={() => toggleGenre(genre.value)}
            $selected={selectedGenres.includes(genre.value)}
          >
            <Typography variant="paragraphSmall">{t(genre.text)}</Typography>
          </Category>
        ))}
      </Categories>
      <Divider color="color14" tMargin={isPhoneResolution ? 20 : 40} bMargin={isPhoneResolution ? 20 : 32} />
      <Stack justifyContent="space-between" fullWidth>
        <StyledButton
          {...contextDataAttrs}
          data-alooma-element={ALOOMA.ELEMENTS.FILTER}
          size="medium"
          onClick={closeModal}
        >
          {t('app:showGames')}
        </StyledButton>
        <Button
          {...contextDataAttrs}
          data-alooma-element={ALOOMA.ELEMENTS.RESET}
          onClick={resetHandler}
          type="underlinedText"
          size="small"
        >
          {t('app:reset')}
        </Button>
      </Stack>
    </Stack>
  );
};

export default ModalBodyKarmaEarnGameGenres;
